import React from 'react';
import { Container } from 'reactstrap';

const DataSubjectRights = () => {
  return (
    <Container className="py-5">
      <div className="legal-document">
        <h1 className="mb-4">Data Subject Rights Policy</h1>
        
        <section className="mb-4">
          <h2>1. Introduction</h2>
          <p>This policy outlines your rights as a data subject under the Protection of Personal Information Act, 2013 ("POPIA") and explains how you can exercise these rights in relation to our SME and Supplier ESG Readiness Tool.</p>
        </section>

        <section className="mb-4">
          <h2>2. Your Rights Under POPIA</h2>
          <h3>2.1 Right to Access</h3>
          <p>You have the right to:</p>
          <ul>
            <li>Request confirmation of whether we hold your personal information</li>
            <li>Request a copy of your personal information</li>
            <li>Request information about third parties who have accessed your data</li>
            <li>Request information about the purpose of processing</li>
          </ul>

          <h3>2.2 Right to Correction</h3>
          <p>You have the right to:</p>
          <ul>
            <li>Request correction of inaccurate personal information</li>
            <li>Request deletion of incorrect or outdated information</li>
            <li>Request updating of incomplete information</li>
          </ul>

          <h3>2.3 Right to Deletion</h3>
          <p>You have the right to request deletion of your personal information when:</p>
          <ul>
            <li>The information is no longer needed for the purpose it was collected</li>
            <li>You withdraw consent and there is no other legal basis for processing</li>
            <li>The information was unlawfully processed</li>
            <li>Deletion is required by law</li>
          </ul>

          <h3>2.4 Right to Object</h3>
          <p>You have the right to object to processing of your personal information when:</p>
          <ul>
            <li>Processing is based on legitimate interests</li>
            <li>Processing is for direct marketing purposes</li>
            <li>Processing is for research or statistical purposes</li>
          </ul>

          <h3>2.5 Right to Restriction</h3>
          <p>You have the right to request restriction of processing when:</p>
          <ul>
            <li>You contest the accuracy of the data</li>
            <li>Processing is unlawful but you oppose deletion</li>
            <li>We no longer need the data but you need it for legal claims</li>
            <li>You have objected to processing pending verification</li>
          </ul>

          <h3>2.6 Right to Data Portability</h3>
          <p>You have the right to:</p>
          <ul>
            <li>Receive your personal information in a structured format</li>
            <li>Transfer your data to another controller</li>
            <li>Request direct transfer where technically feasible</li>
          </ul>

          <h3>2.7 Right to Withdraw Consent</h3>
          <p>You have the right to:</p>
          <ul>
            <li>Withdraw consent at any time</li>
            <li>Object to processing based on consent</li>
            <li>Request cessation of processing after withdrawal</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>3. How to Exercise Your Rights</h2>
          <h3>3.1 Making a Request</h3>
          <p>To exercise your rights, you can:</p>
          <ul>
            <li>Submit a request through our online portal</li>
            <li>Send an email to info@globalcompactsa.org.za</li>
            <li>Contact us by phone at +27 11 771 41 42</li>
            <li>Write to us at 26 Melville Road, Johannesburg, South Africa</li>
          </ul>

          <h3>3.2 Required Information</h3>
          <p>Your request should include:</p>
          <ul>
            <li>Your full name and contact details</li>
            <li>Description of the right you wish to exercise</li>
            <li>Relevant account or reference numbers</li>
            <li>Any supporting documentation</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>4. Response Timeframes</h2>
          <ul>
            <li>We will acknowledge receipt of your request within 5 business days</li>
            <li>We will respond to your request within 30 days</li>
            <li>Complex requests may require an extension of up to 60 days</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>5. Fees</h2>
          <p>We will not charge you for:</p>
          <ul>
            <li>Initial requests to access your information</li>
            <li>Correction of inaccurate information</li>
            <li>Deletion of information</li>
          </ul>
          <p>We may charge a reasonable fee for:</p>
          <ul>
            <li>Substantial requests for copies of information</li>
            <li>Multiple requests from the same person</li>
            <li>Requests that require significant technical resources</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>6. Exceptions and Limitations</h2>
          <p>We may refuse to comply with your request if:</p>
          <ul>
            <li>It would reveal personal information about another person</li>
            <li>It would prejudice law enforcement</li>
            <li>It would harm commercial interests</li>
            <li>It would be manifestly unfounded or excessive</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>7. Complaints</h2>
          <p>If you are dissatisfied with our response, you can:</p>
          <ul>
            <li>Submit a complaint to our internal complaints process</li>
            <li>Contact the Information Regulator of South Africa</li>
            <li>Seek legal advice or representation</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>8. Updates to This Policy</h2>
          <p>We may update this policy to reflect changes in:</p>
          <ul>
            <li>Legal requirements</li>
            <li>Our processing activities</li>
            <li>Our response procedures</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>9. Contact Information</h2>
          <p>For any questions about your data subject rights, please contact:</p>
          <ul>
            <li>Email: info@globalcompactsa.org.za</li>
            <li>Phone: +27 11 771 41 42</li>
            <li>Address: 26 Melville Road, Johannesburg, South Africa</li>
          </ul>
        </section>
      </div>
    </Container>
  );
};

export default DataSubjectRights; 